<template>
  <router-view />
</template>

<script>
export default {
  name: "ShopWrapper"
};
</script>
